import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { resendLinkPath } from '../helpers/paths';
import LogoPage from './LogoPage';
import { SendMagicLinkEmailRequest } from '../models/dto/magicLinkRequest';
import axios from 'axios';

export default function SessionExpiredPage(props: Props) {
	const [resendingLink, setResendingLink] = useState<boolean>(false);
	const [linkResent, setLinkResent] = useState<boolean>(false);
	
	return (
		<LogoPage>
			<div className="text-center">
				<h1 className="h1-mb-1">Your session has expired</h1>
				<div className="mb-3">
					{!linkResent && <button className="btn" disabled={resendingLink} onClick={resendLink}>Email me a new link</button>}
					{linkResent && <span>A link has been sent</span>}
				</div>
				<div><Link to={resendLinkPath}>Use a different email address</Link></div>
			</div>
		</LogoPage>
	);

	function resendLink(): void {
		if (resendingLink || !props.email) return;

		setResendingLink(true);

		const request: SendMagicLinkEmailRequest = { email: props.email };
		axios.post<void>(`/api/token/send-link`, request).then(() => {
			setLinkResent(true);
			setResendingLink(false);
		}, () => {
			setResendingLink(false);
		});
	}
}

interface Props {
    email: string;
}
